/* 🤖 this file was generated by svg-to-ts */
export const iconEllipsisHorizontal = {
    name: 'ellipsis_horizontal',
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" data-source="heroicicons" data-name="solid/ellipsis-horizontal" width="1em" height="1em"><path fill-rule="evenodd" d="M4.5 12a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" clip-rule="evenodd"/></svg>`,
};
